import PropTypes from "prop-types";
import AppUtils from "@src/utils/appUtils";
import { FormProvider, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { COMMON_CONTROLS } from "@src/stories/utils/common-controls";

const Form = ({
  onSubmit,
  children,
  schema,
  options,
  className = "",
  loading = false,
}) => {
  const methods = useForm({
    ...options,
    resolver: schema ? zodResolver(schema) : undefined,
    defaultValues: options?.defaultValues || {},
  });

  return (
    <FormProvider {...methods}>
      <form
        onSubmit={(e) => {
          if (loading) console.debug?.("skipped form submit, loading is true");
          else methods.handleSubmit(onSubmit)(e);
        }}
        className={`space-y-4 ${className}`}
        noValidate
      >
        {children(methods)}
      </form>
    </FormProvider>
  );
};

export const formControls = {
  schema: {
    propType: PropTypes.object,
    description: "Form validation schema",
    controlType: "object",
  },
  options: {
    propType: PropTypes.object,
    description: "Form default values",
    controlType: "object",
  },
  className: COMMON_CONTROLS.className,
  onSubmit: {
    propType: PropTypes.func.isRequired,
    description: "Form submission handler",
    disable: true,
  },
  children: {
    propType: PropTypes.any,
    description: "Form content",
    disable: true,
  },
};

Form.propTypes = AppUtils.getPropTypeFromControls(formControls);

export default Form;
